import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { MBAPL_FINANCIAL_API } from "./apiRoutes";

interface UseGetMbaplFinancialReportingProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getMbaplFinancialReporting = async () =>
  await axiosAuth.get(`${MBAPL_FINANCIAL_API}/`);

const useGetMbaplFinancialReporting = ({
  queryParams,
}: UseGetMbaplFinancialReportingProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["financial-reporting"],
    queryFn: () => getMbaplFinancialReporting(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetMbaplFinancialReporting;
